module.exports = __webpack_public_path__ + "static/img/case_banner_08_h5.c2fc80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_08_h5.png
// module id = 5v8h
// module chunks = 34